module.exports = __webpack_public_path__ + "5146994e4de9f601c3a05aa195ddc23a.MP3";